import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import styles from './evaluate-loading.module.scss'

interface Props {
  duration?: number
}

const EvaluateLoading: React.FC<Props> = ({ duration = 1 }) => {
  const [countdown, setCountdown] = useState(duration)

  useEffect(() => {
    if (countdown <= 0) {
      return
    }
    const timer = setTimeout(() => {
      setCountdown(prev => prev - 1)
    }, 1000)
    return () => clearTimeout(timer)
  }, [countdown])

  return createPortal(
    <div className={styles.page}>
      <div className={styles.spinnerWrap}>
        <img
          className={styles.spinnerImg}
          src={require('@imgs/register/evaluate-spinner.png')}
          alt=""
        />
        <svg className={styles.arcSvg} viewBox="0 0 100 100">
          <circle
            cx="50"
            cy="50"
            r="46"
            fill="none"
            stroke="#4080FF"
            strokeWidth="3.5"
            strokeLinecap="round"
            strokeDasharray="55 234"
          />
        </svg>
      </div>
      <p className={styles.title}>您的借款申请，正在评估({Math.max(countdown, 1)}s)</p>
      <p className={styles.subtitle}>请耐心等待...</p>
    </div>,
    document.body
  )
}

export default EvaluateLoading
